export default [
	{
	  	start: 5700,
	  	previous: 0,
	    scrollDistance: 8000
	},
	{
	  	start: 20600,
	  	previous: 8000,
	    scrollDistance: 23700
	},
	{
	  	start: 25600,
	  	previous: 23700,
	    scrollDistance: 28300
	},
	{
	  	start: 32200,
	  	previous: 28300,
	    scrollDistance: 34400
	},
	{
	  	start: 35400,
	  	previous: 34400,
	    scrollDistance: 37400
	},
	{
	  	start: 40800,
	  	previous: 37400,
	    scrollDistance: 43500
	},
];
